import {useState, useContext} from "react";
import { UserContext } from '../Context/UserContext';
import GameBar from "./GameBar";
import GetPremium from "./GetPremium";
import HitterRatingsTableContainer from "./HitterRatingsTableContainer";
import RatingDropDown from "./RatingDropDown";
import SignupLoginButtons from "./SignupLoginButtons";
import BatterIconLogo from "./BatterIconLogo"
import "../styles/hitterRatingsContainer.css"
import { formatGameDate } from "../utils/formatGameDate";
import {useIsMobile} from "../hooks/useIsMobile"

function HitterRatings() {
    const {state, isActiveSub} = useContext(UserContext);
    //console.log('state', state)
    //console.log('user', state.user.email.length)
    const [ratingTimeframe, setRatingTimeframe] = useState(false)
    //false is default (last 3 seasons), true is current season only
    //console.log('ratingTimeFrame', ratingTimeframe)
    //console.log('state', state)

    function handleChange() {
        setRatingTimeframe(prevTimeframe => !prevTimeframe)
    }

    const gameDate = formatGameDate(state?.games);

     return (
        <div>
            {!state.loggedIn && (
                <div>
                    <div className="ratingsTopContainer">
                        <BatterIconLogo logoID={"ratingsBatterIconLogo"} />
                        <GetPremium className="ratingsGetPremium"/>
                    </div>
                    <SignupLoginButtons className="hitterRatingsSignUpLoginButtons"/>
                </div>
            )}
            {state.loggedIn && !isActiveSub && (
                <div className="loggedInRatingsTopContainer">
                    <BatterIconLogo logoID={"ratingsBatterIconLogo"} />
                    <GetPremium className="ratingsGetPremium"/>
                </div>
            )}
            <h2 className="ratingsHeader">
                MLB Hitter Ratings{gameDate && <> for {gameDate}</>}
            </h2>
            <GameBar />
            {isActiveSub && <RatingDropDown ratingTimeframe={ratingTimeframe} handleChange={handleChange}/>}
            <HitterRatingsTableContainer ratingTimeframe={ratingTimeframe} isActiveSub={isActiveSub}/>
        </div>
    )
}

export default HitterRatings